var styles = {
  "mb0": "pb-marginBottom__mb0",
  "mb1": "pb-marginBottom__mb1",
  "mb2": "pb-marginBottom__mb2",
  "mb3": "pb-marginBottom__mb3",
  "mb4": "pb-marginBottom__mb4",
  "mb5": "pb-marginBottom__mb5",
  "mb6": "pb-marginBottom__mb6",
  "mb7": "pb-marginBottom__mb7",
  "mb8": "pb-marginBottom__mb8",
  "mbm0": "pb-marginBottom__mbm0",
  "mbm1": "pb-marginBottom__mbm1",
  "mbm2": "pb-marginBottom__mbm2",
  "mbm3": "pb-marginBottom__mbm3",
  "mbm4": "pb-marginBottom__mbm4",
  "mbm5": "pb-marginBottom__mbm5",
  "mbm6": "pb-marginBottom__mbm6",
  "mbm7": "pb-marginBottom__mbm7",
  "mbm8": "pb-marginBottom__mbm8",
  "mbl0": "pb-marginBottom__mbl0",
  "mbl1": "pb-marginBottom__mbl1",
  "mbl2": "pb-marginBottom__mbl2",
  "mbl3": "pb-marginBottom__mbl3",
  "mbl4": "pb-marginBottom__mbl4",
  "mbl5": "pb-marginBottom__mbl5",
  "mbl6": "pb-marginBottom__mbl6",
  "mbl7": "pb-marginBottom__mbl7",
  "mbl8": "pb-marginBottom__mbl8"
};
export default styles;